import { render, staticRenderFns } from "./DayOfWeekSelector.vue?vue&type=template&id=38089e81"
import script from "./DayOfWeekSelector.vue?vue&type=script&lang=js"
export * from "./DayOfWeekSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports